import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=223923e4&scoped=true"
import script from "./Install.vue?vue&type=script&lang=js"
export * from "./Install.vue?vue&type=script&lang=js"
import style0 from "./Install.vue?vue&type=style&index=0&id=223923e4&prod&lang=scss&scoped=true"
import style1 from "./Install.vue?vue&type=style&index=1&id=223923e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223923e4",
  null
  
)

export default component.exports